import { usePTPConfigContext } from 'GlobalConfig.context';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import type { LineItemProps, LineItemViewProps } from '../interfaces';
import { useLineItemCommonDisplayInfo } from '../../../../../hooks';

type GetLabelData = (
  eligible: boolean,
  eligibleText: string,
) => {
  color: 'grey' | 'blue';
  text: string;
} | null;

const getLabelDataFactory = (t: TFunction): GetLabelData => {
  return (eligible, eligibleText) => {
    if (eligible) {
      return null;
    }

    return {
      color: 'grey',
      text: eligibleText || t('RETURN_LINE_ITEM_NON_ELIGIBLE'),
    };
  };
};

export const useLineItem = ({
  lineItem,
  selectedLineItem,
  errors,
  onSelectLineItem,
  onDeselectLineItem,
  ...rest
}: LineItemProps): LineItemViewProps => {
  const { t } = useTranslation();
  const returnable = lineItem.eligible;
  const selected = !!selectedLineItem;
  const {
    return: {
      customText: {
        nonEligibleProductLabel: { text },
      },
    },
  } = usePTPConfigContext();

  const getLabelData = getLabelDataFactory(t);
  const label = getLabelData(lineItem.eligible, text);
  const productData = useLineItemCommonDisplayInfo(lineItem);
  const returnData = selected
    ? {
        reason: selectedLineItem.reason,
        quantity: selectedLineItem.quantity,
        customReason: selectedLineItem.customReason,
      }
    : null;

  const onSelectItem = (checked: boolean) => {
    if (checked) {
      onSelectLineItem();
    } else {
      onDeselectLineItem();
    }
  };

  return {
    returnable,
    selected,
    label,
    productData,
    returnData,
    errors,
    onSelectItem,
    ...rest,
  };
};
